import React from 'react'
import { type RJSFSchema, type WidgetProps } from '@rjsf/utils'
import { type ParametersFormContext } from '../formContext'
import { isPlainObject, type JsonObject } from '../mergePatch'
import { fieldNameOf, requiredLabel } from '../rjsf/displayLabel'
import { useExcludedOptionValues } from '../rjsf/excludedOptions'
import { RawReferenceFallback } from './RawReferenceFallback'
import { referenceConfigOf, referenceKindOf } from './registry'

export const ZocksReferenceWidget: React.FC<WidgetProps<JsonObject, RJSFSchema, ParametersFormContext>> = (props) => {
  const annotation = props.options.zocksReference
  const Widget = (isPlainObject(annotation) ? referenceKindOf(annotation.kind)?.Widget : undefined) ?? RawReferenceFallback
  const excludeIds = useExcludedOptionValues(props.id).map(String)
  const widgetProps = {
    value: String(props.value ?? ''),
    onChange: (value: string | undefined) => props.onChange(value),
    disabled: Boolean(props.disabled || props.readonly),
    required: Boolean(props.required),
    label: requiredLabel(fieldNameOf(props.id, props.label, props.schema, props.options.listItem), Boolean(props.required)),
    config: referenceConfigOf(annotation),
    layer: props.registry.formContext.layer,
    id: props.id,
    setFieldUploading: props.registry.formContext.setFieldUploading,
    excludeIds,
  }

  return <Widget {...widgetProps} />
}
